// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.job-log-message-ellipsis {
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
}

.parent_card {
  background-color: #f2f2f2;
  font-size: 12px;
}

.eventinfo-filter-toolbar {
  flex-wrap: wrap;
}

.eventinfo-filter-eventtype-input,
.eventinfo-filter-deployment-input {
  min-width: 14rem;
  max-width: 18rem;
}

::ng-deep .eventinfo-filter-deployment-input .ng-autocomplete {
  display: block;
  width: 100%;
}

::ng-deep .eventinfo-filter-card .autocomplete-container .input-container input::placeholder,
::ng-deep .eventinfo-filter-card .autocomplete-container .input-container input::-webkit-input-placeholder,
::ng-deep .eventinfo-filter-card .autocomplete-container .input-container input::-moz-placeholder,
::ng-deep .eventinfo-filter-card .autocomplete-container .input-container input:-ms-input-placeholder {
  color: #6c757d;
  opacity: 1;
}

.agent_text {
  color: black;
}

.dx-endpoint-block {
  font-size: 12px;
}

/* .row keeps same left alignment as Event Type / Deployment; nowrap prevents flex child wrap */
.dx-endpoint-field-row {
  flex-wrap: nowrap;
}

/* Shrink span to content width so "DX Endpoint: <value>" stays on one line inside .row */
.dx-endpoint-inline {
  white-space: nowrap;
  display: inline-block;
  width: max-content;
  flex: 0 0 auto;
}

.dx-endpoint-url {
  /* display: block; — commented: forced value onto a new line below the label */
  display: inline;
  cursor: pointer;
  /* word-break: break-all; — commented: broke long URLs onto the next line mid-word */
  /* overflow-wrap: anywhere; — commented: allowed wrapping inside narrow column */
  /* white-space: normal; — commented: permitted line wrap for the URL value */
  white-space: nowrap; /* keep full URL on the same line; parent row scrolls horizontally if needed */
  line-height: inherit;
  /* font-family: Consolas, "Courier New", monospace; — commented: monospace differed from other agent_text values */
  /* font-size: 11px; — commented: inherit parent card font size to match Deployment / Event Type */
}

.dx-endpoint-input {
  resize: vertical;
  max-height: 6rem;
  font-family: Consolas, "Courier New", monospace;
  line-height: 1.35;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.expanded-details-card {
  width: 100%;
}

.childexpcard {
  background-color: transparent;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

.active_cardcolor {
  border-left: 4px solid #07a36e;
  background-color: #C3EFF4;
}

.failed_cardcolor {
  border-left: 4px solid #da606c;
  background-color: #C3EFF4;
}

.addconfigbtn {
  background-color: #17a0b4;
  font-size: 12px;
  color: white;
  height: 28px;
  cursor: pointer;
}

.btn_style {
  background-color: #17a0b4;
  color: white;
}

.form-control-sm {
  font-size: 12px !important;
  height: 30px;
}

.input_feild2 {
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
  float: left;
  height: 5vh;
  font-size: 12px !important;
}

.input_feild {
  float: left;
  width: 100%;
}

::ng-deep.eventinfo-modal-add .modal-dialog {
  max-width: 71% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important; /* Center horizontally */
  padding: 0 !important;
}

::ng-deep.eventinfo-modal-add.modal.show {
  top: 56% !important; /* Move to the vertical center */
  transform: translateY(-50%) !important; /* Adjust for the modal's height */
}

::ng-deep.eventinfo-modal-edit .modal-dialog {
  max-width: 71% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important; /* Center horizontally */
  padding: 0 !important;
}

::ng-deep.eventinfo-modal-edit.modal.show {
  top: 56% !important; /* Move to the vertical center */
  transform: translateY(-50%) !important; /* Adjust for the modal's height */
}

/* Match Add Child modal styling with Add modal */
::ng-deep.eventinfo-modal-add-child .modal-dialog {
  max-width: 71% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important; /* Center horizontally */
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/eventinfo/eventinfo.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAf;EACC,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;AAEF;;AAAA;EACE,yBAAA;EACA,eAAA;AAGF;;AAAA;EACE,eAAA;AAGF;;AAAA;;EAEE,gBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,cAAA;EACA,WAAA;AAGF;;AAAA;;;;EAIE,cAAA;EACA,UAAA;AAGF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,eAAA;AAGF;;AAAA,+FAAA;AACA;EACE,iBAAA;AAGF;;AAAA,yFAAA;AACA;EACE,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAGF;;AAAA;EACE,8EAAA;EACA,eAAA;EACA,eAAA;EACA,oFAAA;EACA,gFAAA;EACA,4EAAA;EACA,mBAAA,EAAA,8EAAA;EACA,oBAAA;EACA,kHAAA;EACA,iGAAA;AAGF;;AAAA;EACE,gBAAA;EACA,gBAAA;EACA,+CAAA;EACA,iBAAA;AAGF;;AAAA;EACE,8BAAA;AAGF;;AAAA;EACE,8BAAA;AAGF;;AADA;EACE,WAAA;AAIF;;AADA;EACE,6BAAA;EACA,2BAAA;EACA,8BAAA;AAIF;;AAAA;EACE,8BAAA;EACA,yBAAA;AAGF;;AAAA;EACE,8BAAA;EACA,yBAAA;AAGF;;AAAA;EACE,yBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAGF;;AAAA;EACE,yBAAA;EACA,YAAA;AAGF;;AAAA;EACE,0BAAA;EACA,YAAA;AAGF;;AAAA;EACE,kBAAA;EACA,oDAAA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;AAGJ;;AAAA;EACE,WAAA;EACA,WAAA;AAGF;;AAAA;EACQ,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA,EAAA,wBAAA;EACA,qBAAA;AAGR;;AACM;EACE,mBAAA,EAAA,gCAAA;EACA,sCAAA,EAAA,kCAAA;AAER;;AACM;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA,EAAA,wBAAA;EACA,qBAAA;AAER;;AAAM;EACE,mBAAA,EAAA,gCAAA;EACA,sCAAA,EAAA,kCAAA;AAGR;;AAAM,iDAAA;AACA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA,EAAA,wBAAA;EACA,qBAAA;AAGR","sourcesContent":[" .job-log-message-ellipsis {\r\n  max-width: 180px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n.parent_card {\r\n  background-color: #f2f2f2;\r\n  font-size: 12px;\r\n}\r\n\r\n.eventinfo-filter-toolbar {\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.eventinfo-filter-eventtype-input,\r\n.eventinfo-filter-deployment-input {\r\n  min-width: 14rem;\r\n  max-width: 18rem;\r\n}\r\n\r\n::ng-deep .eventinfo-filter-deployment-input .ng-autocomplete {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n::ng-deep .eventinfo-filter-card .autocomplete-container .input-container input::placeholder,\r\n::ng-deep .eventinfo-filter-card .autocomplete-container .input-container input::-webkit-input-placeholder,\r\n::ng-deep .eventinfo-filter-card .autocomplete-container .input-container input::-moz-placeholder,\r\n::ng-deep .eventinfo-filter-card .autocomplete-container .input-container input:-ms-input-placeholder {\r\n  color: #6c757d;\r\n  opacity: 1;\r\n}\r\n\r\n.agent_text {\r\n  color: black;\r\n}\r\n\r\n.dx-endpoint-block {\r\n  font-size: 12px;\r\n}\r\n\r\n/* .row keeps same left alignment as Event Type / Deployment; nowrap prevents flex child wrap */\r\n.dx-endpoint-field-row {\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n/* Shrink span to content width so \"DX Endpoint: <value>\" stays on one line inside .row */\r\n.dx-endpoint-inline {\r\n  white-space: nowrap;\r\n  display: inline-block;\r\n  width: max-content;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.dx-endpoint-url {\r\n  /* display: block; — commented: forced value onto a new line below the label */\r\n  display: inline;\r\n  cursor: pointer;\r\n  /* word-break: break-all; — commented: broke long URLs onto the next line mid-word */\r\n  /* overflow-wrap: anywhere; — commented: allowed wrapping inside narrow column */\r\n  /* white-space: normal; — commented: permitted line wrap for the URL value */\r\n  white-space: nowrap; /* keep full URL on the same line; parent row scrolls horizontally if needed */\r\n  line-height: inherit;\r\n  /* font-family: Consolas, \"Courier New\", monospace; — commented: monospace differed from other agent_text values */\r\n  /* font-size: 11px; — commented: inherit parent card font size to match Deployment / Event Type */\r\n}\r\n\r\n.dx-endpoint-input {\r\n  resize: vertical;\r\n  max-height: 6rem;\r\n  font-family: Consolas, \"Courier New\", monospace;\r\n  line-height: 1.35;\r\n}\r\n\r\n.active_card {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n\r\n.failed_card {\r\n  border-left: 4px solid #da606c;\r\n}\r\n.expanded-details-card {\r\n  width: 100%;\r\n}\r\n\r\n.childexpcard {\r\n  background-color: transparent;\r\n  padding-top: 6px !important;\r\n  padding-bottom: 6px !important;\r\n}\r\n\r\n\r\n.active_cardcolor {\r\n  border-left: 4px solid #07a36e;\r\n  background-color: #C3EFF4;\r\n}\r\n\r\n.failed_cardcolor {\r\n  border-left: 4px solid #da606c;\r\n  background-color: #C3EFF4;\r\n}\r\n\r\n.addconfigbtn {\r\n  background-color: #17a0b4;\r\n  font-size: 12px;\r\n  color: white;\r\n  height: 28px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_style {\r\n  background-color: #17a0b4;\r\n  color: white;\r\n}\r\n\r\n.form-control-sm {\r\n  font-size: 12px !important;\r\n  height: 30px;\r\n}\r\n\r\n.input_feild2{\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n    float: left;\r\n    height: 5vh;\r\n    font-size: 12px !important;\r\n}\r\n\r\n.input_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n::ng-deep.eventinfo-modal-add .modal-dialog {\r\n        max-width: 71% !important;\r\n        max-height: 60% !important;\r\n        height: 60% !important;\r\n        margin: auto !important; /* Center horizontally */\r\n        padding: 0 !important;\r\n       \r\n      }\r\n\r\n      ::ng-deep.eventinfo-modal-add.modal.show{\r\n        top: 56% !important; /* Move to the vertical center */\r\n        transform: translateY(-50%) !important; /* Adjust for the modal's height */\r\n      }\r\n\r\n      ::ng-deep.eventinfo-modal-edit .modal-dialog {\r\n        max-width: 71% !important;\r\n        max-height: 60% !important;\r\n        height: 60% !important;\r\n        margin: auto !important; /* Center horizontally */\r\n        padding: 0 !important;\r\n      }\r\n      ::ng-deep.eventinfo-modal-edit.modal.show{\r\n        top: 56% !important; /* Move to the vertical center */\r\n        transform: translateY(-50%) !important; /* Adjust for the modal's height */\r\n      }\r\n\r\n      /* Match Add Child modal styling with Add modal */\r\n      ::ng-deep.eventinfo-modal-add-child .modal-dialog {\r\n        max-width: 71% !important;\r\n        max-height: 60% !important;\r\n        height: 60% !important;\r\n        margin: auto !important; /* Center horizontally */\r\n        padding: 0 !important;\r\n      }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
